import { render } from "./SpmGraph.vue?vue&type=template&id=2131b95e&scoped=true"
import script from "./SpmGraph.vue?vue&type=script&lang=ts"
export * from "./SpmGraph.vue?vue&type=script&lang=ts"

import "./SpmGraph.vue?vue&type=style&index=0&id=2131b95e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2131b95e"

export default script